/**
 * Public-facing Zoulloo contact shown on the out-of-platform anonymized talent
 * fiche (the page a prospect opens via a token URL).
 *
 * For now this is a single hard-coded commercial contact, as requested by the
 * business while the feature is in recette. The cleaner long-term design is to
 * surface the CSM who created the TalentSelection — that would require the API
 * to expose the owning CSM's contact in the public DTO
 * (AnonymizedFreelancerProfileResponse), which it does not today. Keep this in
 * one place so the migration is a single edit.
 */
export const ZOULLOO_PUBLIC_CONTACT = {
	name: "Guillaume Weill",
	phone: "+33 (0)6 74 49 38 59",
	email: "gweill@zoulloo.com"
} as const;
